import { render, staticRenderFns } from "./auditRecords.vue?vue&type=template&id=f62d4c70&scoped=true"
import script from "./auditRecords.vue?vue&type=script&lang=js"
export * from "./auditRecords.vue?vue&type=script&lang=js"
import style0 from "./auditRecords.vue?vue&type=style&index=0&id=f62d4c70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62d4c70",
  null
  
)

export default component.exports